import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import getConfig from "../app/config";
import { toast } from 'react-toastify';
import fetchWithRefresh from './fetchWithRefresh';
import { RootState } from '../app/store';

// export const getStratigraphyLookups = createAsyncThunk<any, void>(
//   "stratigraphy/lookups",
//   async (thunkApi) => {
//     const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lookup`, thunkApi, {
//       method: 'Get',
//       headers: {       
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       }
//     });

//     return response;
//   }
// );

// export const getStratigraphyLookup = createAsyncThunk<any, {id: string}>(
//   "stratigraphy/getLookup",
//   async ({id}, thunkApi) => {
//     const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lookup/${id}`, thunkApi, {
//       method: 'Get',
//       headers: {       
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       }
//     });

//     return response;
//   }
// );

export const getStratigraphyLexicons = createAsyncThunk<any, void>(
  "stratigraphy/lexicons",
  async (thunkApi) => {
    const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lexicon`, thunkApi, {
      method: 'Get',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    });

    return response;
  }
);

export const getStratigraphyLexicon = createAsyncThunk<any, {id: string}>(
  "stratigraphy/getLexicon",
  async ({id}, thunkApi) => {
    const response = await fetchWithRefresh(getConfig().apiUrl + `Ltratigraphy/Lexicon/${id}`, thunkApi, {
      method: 'Get',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    });

    return response;
  }
);

export const addStratigraphyLexicon = createAsyncThunk<any, any>(
  "stratigraphy/addLexicon",
  async (stratigraphyLexicon, thunkApi) => {
    const response: any = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lexicon`, thunkApi, {
      method: 'POST',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(stratigraphyLexicon)
    });

    return response;
  }
)

export const updateStratigraphyLexicon = createAsyncThunk<any, any>(
  "stratigraphy/updateLexicon",
  async (stratigraphyLexicon, thunkApi) => {    
    const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lexicon/${stratigraphyLexicon.id}`, thunkApi, {
      method: 'PUT',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(stratigraphyLexicon)
    });

    return response;
  }
)

export const deleteStratigraphyLexicon = createAsyncThunk<any, any>(
  "stratigraphy/deleteLexicon",
  async (stratigraphyLexiconId, thunkApi) => {    
    const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lexicon/${stratigraphyLexiconId}`, thunkApi, {
      method: 'DELETE',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    });

    return response;
  }
)

export const updateStratigraphyLookup = createAsyncThunk<any, any>(
  "stratigraphy/updateLookup",
  async (stratigraphyLookup, thunkApi) => {
    const response = await fetchWithRefresh(getConfig().apiUrl + `Stratigraphy/Lookup/${stratigraphyLookup.id}`, thunkApi, {
      method: 'PUT',
      headers: {       
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(stratigraphyLookup)
    });

    return response;
  }
)

export interface ImageTypeState {
    loading: boolean,
    saving: boolean,
    stratigraphyLookups: any[],
    stratigraphyLexicons: any[],
    stratigraphyLexicon: any,
    stratigraphyLookup: any,
    error: any,    
    addingLexicon: boolean,
    lexiconsLoaded: boolean
  }
  
const initialState: ImageTypeState = {
    loading: false,
    saving: false,
    stratigraphyLookups: [],
    stratigraphyLexicons: [],
    stratigraphyLexicon: null,
    stratigraphyLookup: null,
    error: null,
    addingLexicon: false,
    lexiconsLoaded: false
  }

const stratigraphySlice = createSlice({
    name: 'stratigraphy',
    initialState,
    reducers: {           
      addRow: (state) => {
        state.addingLexicon = true;
        state.stratigraphyLexicons.unshift({ editMode: true });
      },
      deleteAddingRow: (state) => {
        state.addingLexicon = false;
        state.stratigraphyLexicons.splice(0, 1);
      }
    },
    extraReducers:  (builder) => {      
          // builder.addCase(getStratigraphyLookups.pending, (state) => {         
          //   state.error = null;      
          //   state.loading = true;
          // });

          // builder.addCase(getStratigraphyLookups.fulfilled, (state, { payload }) => {   
          //   if (payload?.success || payload.status == 200) {
          //       state.stratigraphyLookups = payload.stratigraphyLookups;
          //   } else {
          //     toast.error("Error getting stratigraphy lookups");
          //   }

          //   state.loading = false;
          // }); 
       
          // builder.addCase(getStratigraphyLookups.rejected, (state, action) => {
          //   debugger;
          //   if (action.payload) {
          //     state.error = action.payload;
          //     toast.error("Error getting stratigraphy lookups");
          //   } else {
          //     state.error = action.error;
          //     toast.error("Error getting stratigraphy lookups");
          //   }

          //   state.loading = false;
          // });

          // builder.addCase(getStratigraphyLookup.pending, (state) => {         
          //   state.error = null;      
          //   state.loading = true;
          // });

          // builder.addCase(getStratigraphyLookup.fulfilled, (state, { payload }) => {   
          //   if (payload?.success || payload.status == 200) {
          //       state.stratigraphyLookup = payload;
          //   } else {
          //     toast.error("Error getting lookup");
          //   }

          //   state.loading = false;
          // }); 
       
          // builder.addCase(getStratigraphyLookup.rejected, (state, action) => {
          //   debugger;
          //   if (action.payload) {
          //     state.error = action.payload;
          //     toast.error("Error getting lookup");
          //   } else {
          //     state.error = action.error;
          //     toast.error("Error getting lookup");
          //   }

          //   state.loading = false;
          // });

          builder.addCase(getStratigraphyLexicons.pending, (state) => {         
            state.error = null;      
            state.loading = true;
          });

          builder.addCase(getStratigraphyLexicons.fulfilled, (state, { payload }) => {   
            if (payload?.success || payload.status == 200) {
                state.stratigraphyLexicons = payload.stratigraphyLexicons;
                state.lexiconsLoaded = true;
            } else {
              toast.error("Error getting lexicons lookups");
            }

            state.loading = false;
          }); 
       
          builder.addCase(getStratigraphyLexicons.rejected, (state, action) => {            
            if (action.payload) {
              state.error = action.payload;
              toast.error("Error getting lexicons lookups");
            } else {
              state.error = action.error;
              toast.error("Error getting lexicons lookups");
            }

            state.loading = false;
          });

          builder.addCase(getStratigraphyLexicon.pending, (state) => {         
            state.error = null;      
            state.loading = true;
          });

          builder.addCase(getStratigraphyLexicon.fulfilled, (state, { payload }) => {   
            if (payload?.success || payload.status == 200) {
                state.stratigraphyLexicon = payload;
            } else {
              toast.error("Error getting lexicon");
            }

            state.loading = false;
          }); 
       
          builder.addCase(getStratigraphyLexicon.rejected, (state, action) => {
            debugger;
            if (action.payload) {
              state.error = action.payload;
              toast.error("Error getting lexicon");
            } else {
              state.error = action.error;
              toast.error("Error getting lexicon");
            }

            state.loading = false;
          });

          builder.addCase(addStratigraphyLexicon.pending, (state) => {         
            state.error = null;      
            state.saving = true;
          });

          builder.addCase(addStratigraphyLexicon.fulfilled, (state, action) => {               
            const newAlternativeId = action.meta.arg.alternativeIds && action.meta.arg.alternativeIds.length > 0 ? action.meta.arg.alternativeIds[0] : null;
            
            state.stratigraphyLexicons[0] = { 
              id: action.payload.id,              
              description: action.meta.arg.description, 
              color: action.meta.arg.color,
              alternativeIds: action.meta.arg.alternativeIds || [],
            };
            
            // Update the alternative lexicon to reference this newly created one back
            if (newAlternativeId) {
              const alternativeLexicon = state.stratigraphyLexicons.find((l: any) => l.id == newAlternativeId);
              if (alternativeLexicon) {
                alternativeLexicon.alternativeIds = [action.payload.id];
              }
            }
            
            state.stratigraphyLexicons.sort((a: any, b: any) => {
              return a.description.toLowerCase().localeCompare(b.description.toLowerCase());
            });

            state.addingLexicon = false;
            state.saving = false;
            toast.success("Successfully added stratigraphy lexicon");
          }); 
       
          builder.addCase(addStratigraphyLexicon.rejected, (state, action) => {            
            if (action.payload) {
              state.error = { data: { errors: action.payload } };
              toast.error("Error adding stratigraphy lexicon");
            } else {
              state.error = action.error;
              toast.error("Error adding stratigraphy lexicon"); 
            }

            state.saving = false;
          });

          builder.addCase(updateStratigraphyLexicon.pending, (state) => {         
            state.error = null;      
            state.saving = true;
          });

          builder.addCase(updateStratigraphyLexicon.fulfilled, (state, action) => {   
            state.saving = false;            
            const lexicon = state.stratigraphyLexicons.find((l: any) => l.id == action.meta.arg.id);
            
            // Get the old alternative ID before updating
            const oldAlternativeId = lexicon.alternativeIds && lexicon.alternativeIds.length > 0 ? lexicon.alternativeIds[0] : null;
            const newAlternativeId = action.meta.arg.alternativeIds && action.meta.arg.alternativeIds.length > 0 ? action.meta.arg.alternativeIds[0] : null;
            
            lexicon.description = action.meta.arg.description;
            lexicon.color = action.meta.arg.color;
            lexicon.alternativeIds = action.meta.arg.alternativeIds;
            
            // If the alternative ID changed, clear the old alternative's reference to this lexicon
            if (oldAlternativeId && oldAlternativeId !== newAlternativeId) {
              const oldAlternativeLexicon = state.stratigraphyLexicons.find((l: any) => l.id == oldAlternativeId);
              if (oldAlternativeLexicon && oldAlternativeLexicon.alternativeIds && oldAlternativeLexicon.alternativeIds.includes(action.meta.arg.id)) {
                oldAlternativeLexicon.alternativeIds = oldAlternativeLexicon.alternativeIds.filter((id: any) => id !== action.meta.arg.id);
              }
            }
            
            // Update the new alternative lexicon to reference this one back
            if (newAlternativeId) {
              const newAlternativeLexicon = state.stratigraphyLexicons.find((l: any) => l.id == newAlternativeId);
              if (newAlternativeLexicon) {
                newAlternativeLexicon.alternativeIds = [action.meta.arg.id];
              }
            }
            
            state.stratigraphyLexicons.sort((a: any, b: any) => {
              return a.description.toLowerCase().localeCompare(b.description.toLowerCase());
            });
            toast.success("Successfully updated stratigraphy lexicon");
          }); 
       
          builder.addCase(updateStratigraphyLexicon.rejected, (state, action) => {            
            if (action.payload) {
              state.error = { data: { errors: action.payload } };
              toast.error("Error updating stratigraphy lexicon");
            } else {
              state.error = action.error;
              toast.error("Error updating stratigraphy lexicon");
            }

            state.saving = false;
          });
          
          builder.addCase(deleteStratigraphyLexicon.pending, (state) => {         
            state.error = null;      
            state.saving = true;
          });

          builder.addCase(deleteStratigraphyLexicon.fulfilled, (state, action) => {   
            state.saving = false;      
            const deletedLexiconId = action.meta.arg;
            const lexiconIndex = state.stratigraphyLexicons.findIndex((l: any) => l.id == deletedLexiconId);
            
            // Remove the deleted lexicon from the array
            state.stratigraphyLexicons.splice(lexiconIndex, 1);
            
            // Find and update any lexicons that had the deleted one as an alternative
            state.stratigraphyLexicons.forEach((lexicon: any) => {
              if (lexicon.alternativeIds && lexicon.alternativeIds.includes(deletedLexiconId)) {
                lexicon.alternativeIds = lexicon.alternativeIds.filter((id: any) => id !== deletedLexiconId);
              }
            });
            
            toast.success("Successfully deleted stratigraphy lexicon");
          }); 
       
          builder.addCase(deleteStratigraphyLexicon.rejected, (state, action) => {            
            if (action.payload) {
              state.error = { data: { errors: action.payload } };
              toast.error("Error deleting stratigraphy lexicon");
            } else {
              state.error = action.error;
              toast.error("Error deleting stratigraphy lexicon");
            }

            state.saving = false;
          });

          builder.addCase(updateStratigraphyLookup.pending, (state) => {         
            state.error = null;      
            state.saving = true;
          });

          builder.addCase(updateStratigraphyLookup.fulfilled, (state, { payload }) => {   
            state.saving = false;
            toast.success("Successfully updated stratigraphy lookup");
          }); 
       
          builder.addCase(updateStratigraphyLookup.rejected, (state, action) => {            
            if (action.payload) {
              state.error = { data: { errors: action.payload } };
              toast.error("Error updating stratigraphy lookup");
            } else {
              state.error = action.error;
              toast.error("Error updating stratigraphy lookup");
            }

            state.saving = false;
          });
    }    
})

export const { addRow, deleteAddingRow } = stratigraphySlice.actions

export const selectStratigraphy = (state: RootState) => state.stratigraphy;

export default stratigraphySlice.reducer; 